module.exports = __webpack_public_path__ + "static/assets/ef43cb0e0435b3dfe0e191a7eaced5e2.png";